<template>
	<!--底部-->
	<!-- <div class="bottom">
		<div class="bottom_box stylePointer">
			<span>
				主办单位：北京中医药知识产权保护申报平台
			</span>
			<span>
				网站管理：北京中医药知识产权
			</span>
			<span>
				联系我们：010-1235795
			</span>
		</div>
		<div class="bottom_box stylePointer">
			<span>
				© 中医药管理处版权所有
			</span>
			<span>
				京ICP备2021035134号-1
			</span>
		</div>
		<div class="bottom_box stylePointer">
			<span>
				地址：北京市海淀区远大路234号
			</span>
		</div>
	</div> -->
	
	
	
	<div  :class="this.$route.name=='homeApprovalDetails' || this.$route.name=='firstPage'?'bottom cursorstyle':'bottom_top bottom cursorstyle'">
		<div class="bott">
			<div class="imgbox">
				<img src="@/assets/bottomMa.png">
			</div>
			<div class="imgbox">
				<img src="@/assets/bottomMa1.png">
			</div>
			<div class="imgtext">
				<div class="">
					主办单位：首都医科大学附属北京中医医院   ｜   网站管理：北京首都中医医疗科技开发公司   ｜   备案号：<a href="https://beian.miit.gov.cn/">京ICP备2021035134号-1</a>
					</div>
				<div class="imgtext2">
					地址：北京市东城区美术馆后街23号   ｜  联系电话：87906976
					</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
	
			}
		}
	}
</script>

<style scoped lang="less">
	
	

/*底部*/
// .bottom{
//     margin-top: 30px;
//     height: 127px;
//     background: #0F7C63;
	
//     width: 100%;
//     overflow: hidden;
// }
// .bottom_box{
//     width: 1100px;
//     margin: 0 auto;
//     text-align: center;
//     font-size: 14px;
//     color: #FFFFFF;
// }
// .bottom>div{
//     margin-top: 10px;
// }
// .bottom>div:first-child{
//     margin-top: 23px;
// }
// .bottom>div:first-child>span{
//     margin-right: 37px;
// }
// .bottom>div:nth-child(2)>span{
//     margin-right: 60px;
// }

.bottom_top{
  margin-top: 30px;

}
.bottom {
		height: 14vh;
		width: 100%;
		background: #0F7C63;
		overflow: hidden;

		.bott {
			// width: 63vw;
			// margin: 0 auto;
			margin-left: 27.2vw;
			margin-top: 4vh;
			display: flex;

			.imgbox {
				width: 3.3vw;
				height: 5.9vh;
				margin-right: 1vw;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.imgtext {
				font-size: 0.87rem;
				color: #FFFFFF;

				.imgtext2 {
					margin-top: 1vh;
					text-align: center;
				}

			}
		}
  a{
    text-decoration: none;
    color: #FFFFFF;
  }

	}
</style>
